import { mergeAttributes, Node } from '@tiptap/core'

/**
 * An atomic inline node that represents a `{{Field}}` placeholder.
 * It renders as a colored chip in the editor UI but serializes to a span
 * carrying `data-placeholder="Field"` and a `{{Field}}` text label, so the
 * existing string-replacement-based renderers still work after `getHTML()`.
 */
export const Placeholder = Node.create({
  name: 'placeholder',

  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: '',
        parseHTML: (el) => el.getAttribute('data-placeholder') || '',
        renderHTML: (attrs) => ({ 'data-placeholder': attrs.name }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-placeholder]',
      },
    ]
  },

  renderHTML({ HTMLAttributes, node }) {
    const name = (node.attrs as any).name || ''
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        class: 'rte-placeholder',
        contenteditable: 'false',
        'data-placeholder': name,
      }),
      `{{${name}}}`,
    ]
  },

  renderText({ node }) {
    return `{{${(node.attrs as any).name || ''}}}`
  },
})
